import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router, NavigationEnd} from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import {NgForm} from "@angular/forms";
import {HttpService} from "../services/http.service";
import {ApiEndpoints} from "../services/api-endpoints";
import { RoamingPartnersComponent } from '../roaming-partners/roaming-partners.component';
import { ServingJoinServersComponent } from '../serving-join-servers/serving-join-servers.component';
import { MessageLogsComponent } from '../message-logs/message-logs.component';
import { RfParamsetsComponent } from '../rf-paramsets/rf-paramsets.component';
import {DevAddrUtils} from "../services/devAddr-utils.service";
import {DateUtils} from "../services/date-utils";
import {StringUtils} from "../services/string-utils";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-get-all-network-servers-detail',
  templateUrl: './get-all-network-servers-detail.component.html',
})

export class GetAllNetworkServersDetailComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  id: any;
  listInfo: Object;
  listStatus: Object;

  listRoamingPartners: any[];
  listServingJoinServers: any[];

  public authTypes: string[] = ['None', 'BasicAuth'];
  public allProtocols: string[] = ['1.0', '1.1'];

  hasAcces: boolean;
  errorStatus: number;
  errorText: string;

  public createRP = true;
  public strOwnership = "";
  public userUrl = ApiEndpoints.GET_USER;
  public logsUrl = ApiEndpoints.GET_NETWORK_SERVER_LOGS;
  public renderNsID = false;
  public renderNsGroup = false;

  httpSubscription: Subscription;

  public statusRefreshing = false;

  @ViewChild('validate') validate: NgForm;
  @ViewChild(RoamingPartnersComponent) roamingPartnersComponent:RoamingPartnersComponent;
  @ViewChild(ServingJoinServersComponent) servingJoinServersComponent: ServingJoinServersComponent;
  @ViewChild(MessageLogsComponent) messageLogsComponent: MessageLogsComponent;
  @ViewChild(RfParamsetsComponent) rfParamSetsComponent: RfParamsetsComponent;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private http: HttpClient,
              private userVerificationService: UserVerificationService,
              private httpService: HttpService) {

    this.isAdmin = this.userVerificationService.isAdmin;

    //get URL parameters
    this.route.params.subscribe(params => {
      window.scrollTo(0, 0);
      this.id = params['virtId'];

      this.httpSubscription = this.httpService.getNetworkInfo(this.id)
        .subscribe((data: any) => {
          this.listInfo = data;
          if (data.username == 'Default') {
            this.username = '';
          } else {
            this.username = data.username;
            if (data.affiliation !== undefined && data.affiliation !== "") {
              this.strOwnership = data.username + ' / ' + data.affiliation;
            } else {
              this.strOwnership = data.username;
            }
          }
          this.hasAcces = true;
          this.getAllNetworkServerDetails();
          this.getNetworkServiceName(data.name);
          this.renderNsID = this.listInfo['protocolVersion'] != '1.0';
          if(this.listInfo['nsGroupId']) this.renderNsGroup = true;
        }
        , (err) => {
          this.hasAcces = false;
          this.errorStatus = err.status;
          this.errorText = err.statusText;
        });
    });
  }

  getNetworkServiceName(networkName) {
    var serverName = networkName;
    $("#menu1sub1").remove();
    var html = '<div class="collapse show width-100-perc" id="menu1sub1"><a class="list-group-item transition item-sub sub active" data-parent="#menu1sub1">' + serverName + '</a></div>';
    $(".network-servers").after(html);
  }

  getAllNetworkServerDetails() {
    var vId = this.listInfo['virtId'];;
    this.Status(this.id);
  }

  //get Status widget
  Status(id) {
    this.listStatus = {};
    var body: any = {"virtId": id};
    var url = ApiEndpoints.GET_NETWORK_SERVER_STATUS;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.listStatus = data;
        }
      );
  }

  // refresh components
  refreshNsStatus() {
    this.listStatus = {};
    this.statusRefreshing = true;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    var bodyStatus: any = {"virtId": this.id};
    var urlStatus = ApiEndpoints.GET_NETWORK_SERVER_STATUS;
    this.http.post<any>(urlStatus, bodyStatus, options).subscribe(
        data => {
          this.listStatus = data
          this.statusRefreshing = false;
        }
      );
  }

  refreshNetworkServer() {
    this.listInfo = {};
    let username = KeycloakService.username;
    var body: any = {"username": username, "virtId": this.id};
    var url = ApiEndpoints.GET_NETWORK_SERVER;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
            data => {
              this.listInfo = data
              var vId = this.listInfo['virtId'];
              this.refreshSubComponents(vId);
            }
          );
  }

  refreshSubComponents(vId) {
    var end = DateUtils.addDays(new Date(), 1);
    var start = DateUtils.subtractDays(end, 3);
    // TODO: Investigate how to do refresh on subcomponent
    this.roamingPartnersComponent.RoamingPartners(vId);
    this.servingJoinServersComponent.ServingJoinServers(vId);
    this.roamingPartnersComponent.getAllNetworkServerWithoutRoamingRelationship(vId);
    this.servingJoinServersComponent.getAllJoinServersWithoutActivationAgreement(vId);
    this.messageLogsComponent.Logs(vId, start.getTime().toString(), end.getTime().toString());
    this.rfParamSetsComponent.RfParamSets(vId);
  }

  nsGroupRemoved() {
    this.refreshNetworkServer();
    this.toggleRenderNsGroup();
  }

  insertSpacesBetweenIds(ids: Array<string>) {
    return StringUtils.insertSpacesBetweenIds(ids);
  }


  toggleRenderNsID(protocolVersion) {
    if(protocolVersion === "1.0") this.renderNsID = false;
    else this.renderNsID = true;
  }

  ngOnInit() {
    $(document).on("click", ".network-servers", function (e) {
      $("#menu0sub1").remove();
      $("#menu1sub1").remove();
      $("#menu2sub1").remove();
      $("#menu3sub1").remove();
      $("#menu2").removeClass("show");
    });
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.refreshSubComponents(this.id);
    });
  }

  roamingPartnersLoaded(partners) {
    this.listRoamingPartners = partners;
    this.roamingPartnersComponent.resetPager();
  }

  servingJoinServersLoaded(servingJSs) {
    this.listServingJoinServers = servingJSs;
    this.servingJoinServersComponent.resetPager();
  }

  isNsGroupMember(item): boolean {
    if(item['nsGroupId']) return true; else return false;
  }

  toggleRenderNsGroup() {
    if(this.renderNsGroup == false) {
      if(this.listRoamingPartners.length == 0 && this.listServingJoinServers.length == 0) this.renderNsGroup = true;
    } else this.renderNsGroup = false;
  }

  navigateTo(item) {
    this.router.navigate(['/network', item.virtId]).then();
  }

  ngOnDestroy() {
    $("#menu1sub1").removeClass("show");
  }

}
